//Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes
import AvaliacaoRespostaTexto from './AvaliacaoRespostaTexto';
import AvaliacaoRespostaInteiro from './AvaliacaoRespostaInteiro';
import AvaliacaoRespostaNumerico from './AvaliacaoRespostaNumerico';
import AvaliacaoRespostaEscolha from './AvaliacaoRespostaEscolha';
import AvaliacaoRespostaMultiplaEscolha from './AvaliacaoRespostaMultiplaEscolha';
import AvaliacaoRespostaImagem from './AvaliacaoRespostaImagem';
import AvaliacaoRespostaTextoFixo from './AvaliacaoRespostaTextoFixo';
//Models
import ModeloAvaliacaoResposta from '../../models/AvaliacaoResposta';
import { TIPO_ESCOLHA, TIPO_FOTO, TIPO_INTEIRO, TIPO_MULTIPLAESCOLHA, TIPO_NUMERICO, TIPO_TEXTO, TIPO_TEXTO_FIXO } from '../../models/QuestionarioQuestao';

/**
 * Componente para renderizar o campo para preenchimento da resposta de acordo com o tipo de questão
 */
class AvaliacaoResposta extends Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleQuestaoChange = this.handleQuestaoChange.bind(this);
    }

    /**
     * Repassa o evento de alteração para o componente pai
     * @param {ModeloAvaliacaoResposta} questao Dados atualizados da questão
     */
    handleQuestaoChange(questao) {
        if (this.props.onChange)
            this.props.onChange(questao);
    }

    render() {
        const questao = this.props.questao;
        const erro = this.props.erro ?? {};

        if (questao.tipo === TIPO_TEXTO)
            return <AvaliacaoRespostaTexto questao={questao} erro={erro} onChange={this.handleQuestaoChange} />;
        else if (questao.tipo === TIPO_INTEIRO)
            return <AvaliacaoRespostaInteiro questao={questao} erro={erro} onChange={this.handleQuestaoChange} />;
        else if (questao.tipo === TIPO_NUMERICO)
            return <AvaliacaoRespostaNumerico questao={questao} erro={erro} onChange={this.handleQuestaoChange} />;
        else if (questao.tipo === TIPO_ESCOLHA)
            return <AvaliacaoRespostaEscolha questao={questao} erro={erro} onChange={this.handleQuestaoChange} />;
        else if (questao.tipo === TIPO_MULTIPLAESCOLHA)
            return <AvaliacaoRespostaMultiplaEscolha questao={questao} erro={erro} onChange={this.handleQuestaoChange} />;
        else if (questao.tipo === TIPO_FOTO)
            return <AvaliacaoRespostaImagem questao={questao} erro={erro} onChange={this.handleQuestaoChange} />;
        else if (questao.tipo === TIPO_TEXTO_FIXO)
            return <AvaliacaoRespostaTextoFixo questao={questao} />;
        else
            return <div>Tipo de questão não implementada - {questao.tipo}. Questão: {questao.titulo}</div>;
    }
}

AvaliacaoResposta.propTypes = {
    /** Objeto contendo os dados da questão a ser respondida */
    questao: PropTypes.instanceOf(ModeloAvaliacaoResposta).isRequired,
    /** Mensagens de erro da resposta */
    erro: PropTypes.object,
    /** Evento disparado quando a resposta for alterada */
    onChange: PropTypes.func,
};

export default AvaliacaoResposta;